import React from "react";

import {
  Card,
  CardBody
} from "../../../../../_metronic/_partials/controls";
import {useIntl} from "react-intl";
import {Redirect, Route, Switch} from "react-router-dom";
import {ROUTE_PREFIX} from "../../helpers/RoutingHelpers";
import {PersonalForm} from "./personal/PersonalForm";
import {PasswordForm} from "./password/PasswordForm";
import {Awards} from "./awards/Awards";
import {Experiences} from "./experiences/Experiences";
import {Educations} from "./educations/Educations";
import {AESVG} from "../../../../../_emywork/components/svg";
import {AELink} from "../../../../../_emywork/components/AELink";
import {matchPath} from "react-router";

export function Edit({ history, match: { params: { slug, ...params }, ...match}}) {
  const {formatMessage} = useIntl()
  const _route = slug ? `${ROUTE_PREFIX}/:username/edit` : `/update-profile`

  const _routes = [
    {
      id: 'PERSONAL_INFORMATION',
      path: `${_route}/personal-information`,
      component: PersonalForm,
      svg: '/Code/Info-circle.svg'
    },
    {
      id: 'CHANGE_PASSWORD',
      path: `${_route}/password`,
      component: PasswordForm,
      svg: '/Home/Key.svg'
    },
    {
      id: 'AWARDS',
      path: `${_route}/awards`,
      component: Awards,
      svg: '/General/Bookmark.svg'
    },
    {
      id: 'EXPERIENCES',
      path: `${_route}/experiences`,
      component: Experiences,
      svg: '/Tools/Tools.svg'
    },
    {
      id: 'EDUCATIONS',
      path: `${_route}/educations`,
      component: Educations,
      svg: '/Home/Book-open.svg'
    }
  ]

  return (
    <>
      {
        !slug &&
        <Card>
          <CardBody>
            <ul
              className="dashboard-tabs nav nav-pills nav-primary row row-paddingless m-0 p-0 flex-column flex-sm-row"
              role="tablist"
            >
              {
                _routes.map(routeProps=>{
                  const match = matchPath(
                    history.location.pathname,
                    {
                      path: routeProps.path,
                      exact: true,
                      strict: false
                    });
                  return (
                    <li
                      key={routeProps.id}
                      className="nav-item d-flex col-sm flex-grow-1 flex-shrink-0 mr-3 mb-3 mb-lg-0">
                      <AELink
                        to={routeProps.path.replace(':username', slug)}
                        className={`nav-link border py-10 d-flex flex-grow-1 rounded flex-column align-items-center ${match ? 'active' : ''}`}
                      >
                      <span className="nav-icon py-2 w-auto">
                        <AESVG
                          path={routeProps.svg}
                          size={'3x'}
                        />
                      </span>
                        <span className="nav-text font-size-lg py-2 font-weight-bolder text-center">
                          {formatMessage({id: routeProps.id})}
                        </span>
                      </AELink>
                    </li>

                  )
                })
              }
            </ul>
          </CardBody>
        </Card>
      }

      <Switch>
        <Redirect exact={true} from={_route} to={`${_route}/personal-information`} />
        {
          _routes.map(routeProps=>(
            <Route
              key={routeProps.id}
              {...routeProps}
            />
          ))
        }
        {/*<Route path={`${_route}/personal-information`} component={PersonalForm}/>*/}
        {/*<Route path={`${_route}/password`} component={PasswordForm}/>*/}
        {/*<Route path={`${_route}/awards`} component={Awards}/>*/}
        {/*<Route path={`${_route}/experiences`} component={Experiences}/>*/}
        {/*<Route path={`${_route}/educations`} component={Educations}/>*/}
      </Switch>
    </>
  );
}
